import { render, staticRenderFns } from "./DoctorRegisterList.vue?vue&type=template&id=3a918636&scoped=true&"
import script from "./DoctorRegisterList.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterList.vue?vue&type=style&index=0&id=3a918636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a918636",
  null
  
)

export default component.exports